export const LoggingService = {
  Log(content: any) {
    console.log(content);
  },
};
